// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__4Y33D","lastLink":"HeadPage_lastLink__NpUcx"};